import { useInAppBrowser } from 'App/capacitor';
import { TIENDA_NUBE_THEMES_LINKS } from 'commons/constants';
import { useTranslationLanguage } from 'commons/hooks';

export function useGoToThemesStore() {
  const language = useTranslationLanguage();
  const openInAppBrowser = useInAppBrowser();

  const handleGoToThemesStore = async () => {
    await openInAppBrowser(TIENDA_NUBE_THEMES_LINKS[language]);
  };

  return handleGoToThemesStore;
}
